import LegalLayout from "./LegalLayout";

export default function Refund() {
  return (
    <LegalLayout title="Refund Policy" path="/legal/refund" description="Refund policy for erotic hypnosis session deposits and media purchases via external platforms. Session deposits are non-refundable within 48 hours of appointment.">
      <p>Deposits are non-refundable within 48 hours of the scheduled appointment. Beyond that window, deposits may be transferred to another date by arrangement.</p>
      <p>Media purchases made via external platforms (Unlockt.me, Clips4sale, iWantClips) are governed by the relevant platform's refund policy. We will assist with delivery issues where possible.</p>
      <p>Where a fly-on-the-wall recording fails on a technical level (e.g., a corrupt file delivered), a replacement file or a credit will be offered.</p>
    </LegalLayout>
  );
}
